import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import type { ReactNode } from 'react';

// biome-ignore lint/style/useComponentExportOnlyModules: file provided by tanstack-router
export const getContext = () => ({
  queryClient: new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
      mutations: {
        retry: false,
      },
    },
  }),
});

export const Provider = ({
  children,
  queryClient,
}: {
  children: ReactNode;
  queryClient: QueryClient;
}) => <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>;
